import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Inicio", href: "#hero" },
  { label: "Cómo funciona", href: "#how-it-works" },
  { label: "Catálogo", href: "#featured" },
  { label: "FAQ", href: "#faq" },
];

export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card/80 backdrop-blur-md border-b border-border">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <Link to="/" className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-full bg-primary flex items-center justify-center">
            <span className="text-primary-foreground font-heading font-bold text-sm">SV</span>
          </div>
          <span className="font-heading font-bold text-lg text-foreground">Senda de Vida</span>
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map(l => (
            <a key={l.href} href={l.href} className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link to="/admin/dashboard">
            <Button variant="ghost" size="sm">Admin</Button>
          </Link>
          <Button variant="hero" size="sm">Comenzar gratis</Button>
        </div>

        <button className="md:hidden" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-card border-b border-border p-4 space-y-3">
          {navLinks.map(l => (
            <a key={l.href} href={l.href} className="block text-sm font-medium text-muted-foreground" onClick={() => setMobileOpen(false)}>
              {l.label}
            </a>
          ))}
          <Link to="/admin/dashboard" onClick={() => setMobileOpen(false)}>
            <Button variant="ghost" size="sm" className="w-full">Admin</Button>
          </Link>
          <Button variant="hero" size="sm" className="w-full">Comenzar gratis</Button>
        </div>
      )}
    </header>
  );
}
